// extracted by mini-css-extract-plugin
export default {"container":"Pagination_container__PujMJ","pageLink":"Pagination_pageLink__ZHK9W","active":"Pagination_active__iiDc9","inactive":"Pagination_inactive__ZlbP7"};